export default [
    //FOR Adjustment Manager========================================================================
    {
        subject: "adjustments",
        key: "New Adjustments", //this is the parameter found in the url /form/:key 
        pageTitle: "New Adjustments",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "New Adjustments",
                userId:"",
            },
            filterEndpoint: "getAdjustmentByUser",
            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {  
                status: "New Adjustments",
                userId: "" // we set this on the fly
            }
        },
    },
    {
        subject: "adjustments",
        key: "View Pending Adjustment", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending Adjustments",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted HOD",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentByUser",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "adjustments",
        key: "View Approved Adjustment", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved Adjustments",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved Adjustment",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentByUser",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "adjustments",
        key: "View Rejected Adjustment", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Adjustments",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected Adjustment",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentByUser",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },

   
    //------------------------------------------------------------------------------------------
  
    //FOR Adjustment Approver========================================================================
    {
        subject: "adjustments",
        key: "HOD Pending Approval", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending for Approval by HOD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: { 
                status: "Submitted HOD",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentsByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "adjustments",
        key: "Approved Adjustment", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved Adjustments",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved Adjustment",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentsByBranchAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    {
        subject: "adjustments",
        key: "Rejected Adjustment", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Adjustment",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "adjustmentnotes", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected Adjustment",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getAdjustmentsByBranchAndStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    //----------------------------------------------------------------------------------------------
]